<template>
  <card extra-classes="bg-white px-4 py-5 sm:px-6">
    <h2 id="nurture-title" class="text-lg font-medium text-gray-900">Nurture</h2>
    <div class="mt-2">
      <ToggleInput
        label="Automatic Follow-up"
        description="Automatically sends a follow-up message on the follow-up date inputted below."
        :modelValue="contact.nurtureActive"
        @update:modelValue="contact.nurtureActive = $event"
      />
      <DateInput
        class="mt-2"
        label="Follow-up Date"
        :modelValue="contact.nurtureAt"
        @update:modelValue="contact.nurtureAt = $event"
      />
      <TextAreaInput
        class="mt-2"
        label="Follow-up Message"
        :modelValue="contact.nurtureMessage"
        @update:modelValue="contact.nurtureMessage = $event"
      />
      <TButton class="mt-2" label="Save" color="indigo" @click="updateContact()">
        <LocalLoadingSpinner />
      </TButton>
    </div>
  </card>
</template>

<script>
import Card from '../Card/index.vue';

export default {
  props: ['contact'],
  components: {
    Card,
  },
  methods: {
    updateContact() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch(`/api/contacts/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          nurture_active: self.contact.nurtureActive,
          nurture_at: self.contact.nurtureAt,
          nurture_message: self.contact.nurtureMessage,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          if (data.status != 'error') {
            await self.$router.push(`/contacts/${self.$route.params.id}`);
            self.$store.commit('general/showAlert', {
              alertType: 'success',
              alertTitle: 'Contact nurture updated',
              alertDescription:
                'Your contact nurture schedule was successfully updated.  Use the button below to dismiss this alert.',
            });
          } else {
            self.$store.commit('general/showAlert', {
              alertType: 'error',
              alertTitle: 'Contact nurture update error',
              alertDescription: data.message,
            });
          }
        });
    },
  },
};
</script>
